import { render, staticRenderFns } from "./RequestSchoolModal.vue?vue&type=template&id=bf193ca8&scoped=true&"
import script from "./RequestSchoolModal.vue?vue&type=script&lang=js&"
export * from "./RequestSchoolModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf193ca8",
  null
  
)

export default component.exports